import type {
  PurchaseOrderStatus,
  PurchaseReceptionStatus,
  PurchaseReturnStatus,
} from './purchaseTypes';

import { formatMoney } from '../../shared/format/public-api';
export const PURCHASE_ORDER_STATUS_LABELS: Record<PurchaseOrderStatus, string> = {
  draft: 'Borrador',
  sent: 'Enviada',
  partial: 'Recepción parcial',
  received: 'Recibida',
  cancelled: 'Anulada',
  closed: 'Cerrada',
};

export const PURCHASE_RECEPTION_STATUS_LABELS: Record<PurchaseReceptionStatus, string> = {
  active: 'Activa',
  voided: 'Anulada',
};

export const PURCHASE_RETURN_STATUS_LABELS: Record<PurchaseReturnStatus, string> = {
  active: 'Activa',
  voided: 'Anulada',
};

export function purchaseOrderStatusLabel(status: PurchaseOrderStatus): string {
  return PURCHASE_ORDER_STATUS_LABELS[status] ?? status;
}

export function purchaseReceptionStatusLabel(status: PurchaseReceptionStatus): string {
  return PURCHASE_RECEPTION_STATUS_LABELS[status] ?? status;
}

export function purchaseReturnStatusLabel(status: PurchaseReturnStatus): string {
  return PURCHASE_RETURN_STATUS_LABELS[status] ?? status;
}

/** §16.7 — informativo, no toca montos. Retorna null si no hay crédito. */
export function purchaseCreditBannerText(creditAmount: number): string | null {
  if (creditAmount > 0) {
    const label = formatMoney(creditAmount);
    return `Tenés ${label} de crédito por la devolución. Descontalo a mano en el próximo pago.`;
  }
  return null;
}
